import { ChangeEvent } from 'react';

import { exceptPercentageAndBrackets } from './regexes';

export interface FormField {
  value: string;
  error: boolean;
  visited: boolean;
}

export interface BannerValues{
  successBanner:boolean;
  errorBanner:boolean;
  requestFailBanner:boolean;
}

export type SuggestAppFieldType = 'MERCHANT_ID' | 'MERCHANT_NAME' | 'EMAIL' | 'OWNER' | 'APP_SUGGESTION' | 'CONTACT_MERCHANT'

export const SuggestAppFormField: Record<SuggestAppFieldType, string> = {
  MERCHANT_ID: 'entry.1601010241',
  MERCHANT_NAME: 'entry.374563694',
  EMAIL: 'entry.1093313791',
  OWNER: 'entry.437335352',
  APP_SUGGESTION: 'entry.296130877',
  CONTACT_MERCHANT: 'entry.483945209'
};

export const validateFormFieldValue = (valLen: number, minValLen: number, value: string = ''): boolean => {
  let validity = true;
  if (!value || valLen < minValLen || !exceptPercentageAndBrackets.test(value)) {
    validity = false;
  }
  return validity;
};

export const getValueFromEvent = (event: ChangeEvent): string => {
  let target = event.target as HTMLTextAreaElement | HTMLInputElement;

  return target.value || '';
};

type ParamValueType = Maybe<number | string | boolean | null>;

export const buildQueryParamsString = (
  queryParams: Record<string, ParamValueType> | { name: string; value: ParamValueType }[],
) => {
  let stringifiedQueryParams = '';

  if (Array.isArray(queryParams)) {
    stringifiedQueryParams = queryParams
      .map(paramObj => `${encodeURIComponent(paramObj.name)}=${encodeURIComponent(String(paramObj.value))}`)
      .join('&');
  } else if (typeof queryParams === 'object') {
    stringifiedQueryParams = Object.keys(queryParams)
      .sort()
      .filter(key =>
        typeof queryParams[key] === 'string' ? Boolean(queryParams[key]) : queryParams[key] !== undefined,
      )
      .map(key => `${key}=${encodeURIComponent(String(queryParams[key]))}`)
      .join('&');
  }

  return stringifiedQueryParams ? `${stringifiedQueryParams}` : '';
};
